import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import axios from "axios";

// const data = [
//   // "https://shophoakieutrinh.com/wp-content/uploads/2021/05/hinh-thuc-te-17.jpg",
//   // "https://shophoakieutrinh.com/wp-content/uploads/2021/05/hinh-thuc-te-10.jpg",
//   // "https://shophoakieutrinh.com/wp-content/uploads/2021/05/hinh-thuc-te-1.jpg",
//   // "https://shophoakieutrinh.com/wp-content/uploads/2021/05/hinh-thuc-te-5.jpg",
//   // "https://shophoakieutrinh.com/wp-content/uploads/2021/05/hinh-thuc-te-6.jpg",
//   // "https://shophoakieutrinh.com/wp-content/uploads/2021/05/hinh-thuc-te-7.jpg",
//   // "https://shophoakieutrinh.com/wp-content/uploads/2021/05/hinh-thuc-te-8.jpg",
//   // 'https://shophoakieutrinh.com/wp-content/uploads/2021/05/hinh-thuc-te-9.jpg',
//   // 'https://shophoakieutrinh.com/wp-content/uploads/2021/05/hinh-thuc-te-11.jpg',
//   "https://shophoakieutrinh.com/wp-content/uploads/2021/05/hinh-thuc-te-13.jpg",
//   "https://shophoakieutrinh.com/wp-content/uploads/2021/05/hinh-thuc-te-14.jpg",
//   "https://shophoakieutrinh.com/wp-content/uploads/2021/05/hinh-thuc-te-16.jpg",
//   "https://shophoakieutrinh.com/wp-content/uploads/2021/05/hinh-thuc-te-18.jpg",
//   "https://shophoakieutrinh.com/wp-content/uploads/2021/05/hinh-thuc-te-19.jpg",
//   "https://shophoakieutrinh.com/wp-content/uploads/2021/05/hinh-thuc-te-20.jpg",
//   "https://shophoakieutrinh.com/wp-content/uploads/2021/05/hinh-thuc-te-2.jpg",
// ];

const ImageSlider = () => {
  const [currentSlide, setCurrentSlide] = useState(null);
  const [data, setData] = useState([]);

  const settings = {
    dots: false,
    infinite: data.length > 7,
    speed: 500,
    slidesToShow: 7,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    arrows: false,
    centerMode: true,
    centerPadding: data.length > 7 ? "50px" : 0,
    afterChange: (current) => {
      if (data.length > 7) {
        setCurrentSlide(current);
      }
    },
    focusOnSelect: true,
    snapToChildren: true,
    responsive: [
      {
        breakpoint: 431,
        settings: {
          slidesToShow: 1,
          centerPadding: "100px",
        },
      },
    ],
  };

  useEffect(() => {
    getData();
  }, []);

  const getData = () => {
    axios
      .get(`/api/v1/images`, {
        params: {
          isHome: 1,
        },
      })
      .then((res) => {
        setData(res.data.images);
      })
      .catch((err) => console.log(err));
  };

  return (
    <div className="image-slider-container">
      <div className="image-slider-title">
        <div className="image-slider-title-text">
          <i className="bi bi-heart-fill me-2"></i>Hình Ảnh Tại Nơi Giao
        </div>
      </div>
      <div className="image-slider-content mt-4">
        <Slider {...settings}>
          {data.map((item, idx) => (
            <div
              className={`image-slider-item ${
                idx === currentSlide ? "active" : ""
              }`}
              key={idx}
            >
              <img src={item.path} alt="" />
            </div>
          ))}
        </Slider>
      </div>
    </div>
  );
};

export default ImageSlider;
